export * from './aws.ngReact';
export * from './aws.react.injector';



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./app/scripts/modules/amazon/src/reactShims/index.ts